// extracted by mini-css-extract-plugin
export default {"CommentsButton":"ij_a bhf_wv bhf_iz bhf_xj bhf_i bhf_j bhf_q bhf_vr bhf_er bhf_sm bhf_sn bhf_eb","CommentsButton__icon":"ij_b bhf_rx"};